export default __webpack_public_path__ + "static/media/icon-alert-info.5a546e72.svg";